import { LearnPage } from '@features/learn/LearnPage'
import { SpeciesPage } from '@features/learn/SpeciesPage'
import { MagicPlacePage } from '@features/magic/MagicPlacePage'
import { KeptMap } from '@features/map/KeptMap'
import { GalleryPage } from '@features/more/GalleryPage'
import { MorePage } from '@features/more/MorePage'
import { PanelApp } from '@features/panel/PanelApp'
import { PlacePage } from '@features/places/PlacePage'
import { ReportPage } from '@features/report/ReportPage'
import { ScanPage } from '@features/scan/ScanPage'
import { StageDetailPage } from '@features/stages/StageDetailPage'
import { StagesPage } from '@features/stages/StagesPage'
import { TreePage } from '@features/tree/TreePage'
import { useI18n } from '@i18n/I18nProvider'
import { ButtonLink } from '@ui/Button'
import { Screen } from '@ui/Screen'
import { Route, Switch } from 'wouter'
import { BottomNav } from './BottomNav'
import { Header } from './Header'

export const NotFound = () => {
	const { t } = useI18n()
	return (
		<Screen>
			<div className="flex flex-col items-center gap-4 py-12 text-center">
				<p className="text-lg">{t('common.notFound')}</p>
				<ButtonLink href="/">{t('common.goHome')}</ButtonLink>
			</div>
		</Screen>
	)
}

// Rutas de la webapp. `/a/:código` es la URL que codifica el QR de cada árbol: no cambiarla
// (los QR impresos dejarían de funcionar). El mapa (`/`) no va aquí: lo pinta KeptMap, que lo
// mantiene montado al cambiar de pantalla.
export const AppRoutes = () => (
	<Switch>
		<Route path="/a/:code/aviso">{(params) => <ReportPage code={params.code} />}</Route>
		<Route path="/a/:code">{(params) => <TreePage code={params.code} />}</Route>
		<Route path="/">{null}</Route>
		<Route path="/escanear">{() => <ScanPage />}</Route>
		<Route path="/etapas/:id">{(params) => <StageDetailPage id={params.id} />}</Route>
		<Route path="/etapas" component={StagesPage} />
		<Route path="/lugares/:id">{(params) => <PlacePage id={params.id} />}</Route>
		<Route path="/formacion/especies/:id">{(params) => <SpeciesPage id={params.id} />}</Route>
		<Route path="/formacion" component={LearnPage} />
		<Route path="/mas/galeria" component={GalleryPage} />
		<Route path="/lugar-magico" component={MagicPlacePage} />
		<Route path="/mas" component={MorePage} />
		<Route path="/panel" nest>
			<PanelApp />
		</Route>
		<Route component={NotFound} />
	</Switch>
)

export const App = () => (
	<div className="min-h-dvh">
		<Header />
		<KeptMap />
		<AppRoutes />
		<BottomNav />
	</div>
)
